export default {
  name: 'InfoDisclosure',
  props: {
    title: {
      type: String,
      required: true
    },
    initiallyOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: this.initiallyOpen
    };
  },
  methods: {
    toggle: function toggle() {
      this.isOpen = !this.isOpen;
    },
    onEnter: function onEnter(el) {
      // если открытие прервало анимацию закрытия — стартуем с текущей высоты
      if (!el.style.height) {
        el.style.height = '0';
        el.style.marginTop = '0';
        el.style.opacity = '0';
      }
      el.style.height = "".concat(el.scrollHeight, "px");
      el.style.marginTop = '';
      el.style.opacity = '';
    },
    onLeave: function onLeave(el) {
      el.style.height = "".concat(el.offsetHeight, "px");
      el.getBoundingClientRect();
      el.style.height = '0';
      el.style.marginTop = '0';
      el.style.opacity = '0';
    },
    resetTransitionStyles: function resetTransitionStyles(el) {
      el.style.height = '';
      el.style.marginTop = '';
      el.style.opacity = '';
    }
  }
};